import type { TMessages } from '@/types/TMessages'

export const messages = {
  actions: {
    sendOrder: 'Подать заявку',
    more: 'Подробнее',
  },
} satisfies TMessages
